module.exports = __webpack_public_path__ + "img/Anhänger_SchlB.7b25bf92.svg";